import React from 'react';
import { getMenuIcon } from '../../../../../utils';
import { AvailableInternalLinkMenuItem } from '../../../../../providers/NavigationProvider/types';
import { SideNavLabel } from '../../SideNavLabel';
import { StyledIconContainer, LevelOneText } from '../../../SideNavMenu/SideNavMenu.styles';
import {
  StyledBlockedLevelOneLink,
  StyledSideNavLevelOneListItem,
  StyledSideNavLevelOneNavLink,
} from './SideNavLevelOneLink.styles';

type SideNavLevelOneLinkProps = {
  exact: boolean;
  isActiveRoute: boolean;
  isBlocked: boolean;
  routePath: string;
  menuItemConfig: AvailableInternalLinkMenuItem;
};

export const SideNavLevelOneLink = ({
  exact,
  isActiveRoute,
  isBlocked,
  routePath,
  menuItemConfig,
}: SideNavLevelOneLinkProps) => {
  const { iconName, label, statusLabel } = menuItemConfig;
  const IconComponent = getMenuIcon(iconName);

  const children = (
    <>
      {IconComponent && (
        <StyledIconContainer data-testid="menu-icon">
          <IconComponent />
        </StyledIconContainer>
      )}
      <LevelOneText>
        <SideNavLabel label={label} statusLabel={statusLabel} />
      </LevelOneText>
    </>
  );

  if (isBlocked) {
    return (
      <StyledSideNavLevelOneListItem>
        <StyledBlockedLevelOneLink>{children}</StyledBlockedLevelOneLink>
      </StyledSideNavLevelOneListItem>
    );
  }

  return (
    <StyledSideNavLevelOneListItem>
      <StyledSideNavLevelOneNavLink to={routePath} exact={exact} $isActiveRoute={isActiveRoute}>
        {children}
      </StyledSideNavLevelOneNavLink>
    </StyledSideNavLevelOneListItem>
  );
};
